import gasanzeCover from "../assets/images/projects/eugene-gasanze/1.jpg";
import gasanzeImg1 from "../assets/images/projects/eugene-gasanze/2.jpg";
import gasanzeImg2 from "../assets/images/projects/eugene-gasanze/3.jpg";
import gasanzeImg3 from "../assets/images/projects/eugene-gasanze/4.jpg";

import kanombeCover from "../assets/images/projects/eugene-kanombe/1.jpg";
import kanombeImg1 from "../assets/images/projects/eugene-kanombe/2.jpg";
import kanombeImg2 from "../assets/images/projects/eugene-kanombe/3.jpg";
import kanombeImg3 from "../assets/images/projects/eugene-kanombe/4.jpg";

import biremboCover from "../assets/images/projects/birembo/1.jpg";
import biremboImg1 from "../assets/images/projects/birembo/2.jpg";
import biremboImg2 from "../assets/images/projects/birembo/3.jpg";
import biremboImg3 from "../assets/images/projects/birembo/4.jpg";

export const projects = [
  {
    slug: 'gasanze-residential-homes',
    title: 'Gasanze Residential Homes',
    category: 'Residential',
    status: 'Completed',
    date: 'May 2024',
    duration: '10 Months',
    location: 'Gasanze, Kigali, Rwanda',

    // HERO
    coverImage: gasanzeCover,

    // GALLERY (IMPORTANT)
    images: [
      gasanzeImg1,
      gasanzeImg2,
      gasanzeImg3,
    ],

    // OVERVIEW
    shortDescription:
      'A modern residential housing project designed with sustainability, comfort, and efficient space utilization in mind.',

    description:
      'Gasanze Residential Homes is a thoughtfully planned housing development consisting of five modern residential units. The project emphasizes sustainable materials, energy efficiency, and contemporary architectural aesthetics while ensuring comfort and durability for residents.',

    // PROJECT INFO
    client: 'Private Developer',
    servicesProvided: [
      'Architectural Design',
      'Structural Engineering',
      'MEP Design',
      'Construction Supervision',
    ],

    area: '2,800 m²',
    budget: 'Confidential',

    // KEY FEATURES
    highlights: [
      'Modern design with sustainable materials',
      'Five residential housing units',
      'Integrated rainwater harvesting system',
      'Solar-powered lighting and heating',
      'Natural ventilation and daylight optimization',
    ],

    // TECHNICAL DETAILS
    specifications: [
      { label: 'Structure', value: 'Reinforced concrete' },
      { label: 'Floors', value: 'Ground + 1' },
      { label: 'Roofing', value: 'Insulated metal sheets' },
      { label: 'Energy', value: 'Solar-assisted systems' },
    ],

    // OPTIONAL
    challenges:
      'Site slope and drainage constraints required innovative foundation and water management solutions.',

    solutions:
      'Advanced site analysis and structural optimization ensured long-term stability and efficient water flow.',

    // SEO
    seo: {
      title: 'Gasanze Residential Homes | Edges Design Group',
      description:
        'Modern residential housing project in Gasanze, Kigali featuring sustainable design, solar systems, and contemporary architecture.',
    },
  },

  {
    slug: 'kanombe-eco-apartments',
    title: 'Kanombe Eco Apartments',
    category: 'Residential / Apartments',
    status: 'Completed',
    date: 'February 2023',
    duration: '14 Months',
    location: 'Kanombe, Kigali, Rwanda',

    coverImage: kanombeCover,
    images: [
      kanombeImg1,
      kanombeImg2,
      kanombeImg3,
    ],

    shortDescription:
      'Eco-friendly apartment development focusing on energy efficiency and community living.',

    description:
      'Kanombe Eco Apartments integrates green architecture principles with modern urban living. The project promotes environmental responsibility while providing high-quality residential spaces.',

    client: 'Real Estate Investor',
    servicesProvided: [
      'Architectural Design',
      'Green Building Consulting',
      'Construction Management',
    ],

    area: '4,200 m²',

    highlights: [
      'High-efficiency ventilation systems',
      'Community green spaces',
      'Underground parking',
      'Accessibility-friendly design',
    ],

    specifications: [
      { label: 'Structure', value: 'Reinforced concrete frame' },
      { label: 'Floors', value: 'G + 3' },
      { label: 'Parking', value: 'Underground' },
    ],

    seo: {
      title: 'Kanombe Eco Apartments | Sustainable Housing Kigali',
      description:
        'Eco-friendly apartment project in Kanombe, Kigali with green spaces, efficient ventilation, and sustainable architecture.',
    },
  },

  {
    slug: 'birembo-commercial-block',
    title: 'Birembo Commercial Block',
    category: 'Commercial',
    status: 'Completed',
    date: 'August 2022',
    duration: '12 Months',
    location: 'Birembo, Kigali, Rwanda',

    coverImage: biremboCover,
    images: [
      biremboImg1,
      biremboImg2,
      biremboImg3,
    ],

    shortDescription:
      'A modern mixed-use commercial building combining retail and office spaces.',

    description:
      'The Birembo Commercial Block is designed to serve both retail and office users, featuring a modern façade, smart building systems, and efficient circulation.',

    client: 'Commercial Developer',
    servicesProvided: [
      'Architectural Design',
      'Structural Engineering',
      'MEP Design',
    ],

    area: '3,600 m²',

    highlights: [
      'Mixed-use retail and office spaces',
      'Energy-efficient glass façade',
      'Smart surveillance and access control',
      'Ample parking facilities',
    ],

    specifications: [
      { label: 'Façade', value: 'Low-E energy-efficient glass' },
      { label: 'Floors', value: 'Ground + 2' },
      { label: 'Security', value: 'Smart access control system' },
    ],

    seo: {
      title: 'Birembo Commercial Block | Commercial Architecture Kigali',
      description:
        'Modern commercial building in Birembo featuring retail, offices, energy-efficient façade, and smart systems.',
    },
  },
]
